import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, Cake, Heart, Building2, UsersRound, Sparkles } from 'lucide-react';

const WhoItsFor = () => {
  const { t } = useLanguage();

  const targets = [
    { icon: <Users size={28} />, text: t('who1') },
    { icon: <Cake size={28} />, text: t('who2') },
    { icon: <Heart size={28} />, text: t('who3') },
    { icon: <Building2 size={28} />, text: t('who4') },
    { icon: <UsersRound size={28} />, text: t('who5') },
    { icon: <Sparkles size={28} />, text: t('who6') }
  ];

  return (
    <section className="bg-black py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('whoTitle')}
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {targets.map((target, index) => (
            <div 
              key={index}
              className="flex flex-col items-center justify-center p-6 md:p-8 bg-white/5 border border-white/10 hover:border-[#00FFD1]/50 transition-all duration-300 group"
            >
              <div className="text-white/60 group-hover:text-[#00FFD1] transition-colors mb-4">
                {target.icon}
              </div>
              <span className="text-white/90 text-center font-medium">{target.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;